import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/reports/historyPoints/filter'; // Importing Filter component
import Table from 'views/reports/historyPoints/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the history movement view.
 * @extends JetView
 */
export default class historyMovementView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme from app config
        const vthis = this; // Reference to the current instance
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns within the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        onChange: function () {
                            // Event handler for change event
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager display
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default size from devConfig
                },
                {
                    view: 'richselect', // Rich select for export options
                    name: 'Export', // Name of the select
                    id: 'Export', // Unique identifier for the select
                    width: 120, // Width of the rich select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Options for export format
                        { id: '1', value: 'Excel' },
                        { id: '2', value: 'PDF' },
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for change event
                            var table = $$('datatable'); // Reference to the datatable
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // Calculate first item index
                            var last = first + size - 1; // Calculate last item index
                            if (value !== '') {
                                // Check if a value is selected
                                vthis.app.callEvent('export:filter', [
                                    // Trigger export event
                                    { value: value, first: first, last: last },
                                ]);
                            }
                        },
                    },
                },
            ],
        };
        const left = {
            rows: [
                // Rows within the left section
                {
                    view: 'toolbar', // Toolbar for search functionality
                    css: theme, // Apply current theme
                    id: 'toolbar-search', // Unique identifier for the search toolbar
                    elements: [
                        { view: 'label', label: _('Historial de puntos') }, // Label for the toolbar
                        {
                            type: 'wide', // Type of the element
                            css: 'close-bottom', // CSS class for styling
                            id: 'button-search', // Unique identifier for the search button
                            cols: [
                                // Columns within the button
                                {
                                    view: 'icon', // Icon for the search button
                                    icon: 'wxi-search', // Icon type
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => {
                                        // Click event handler
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Include the Filter component
                Table, // Include the Table component
                toolbar, // Include the toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Type of the view
            view: 'form', // Form view
            scrollY: true, // Enable vertical scrolling
            css: 'scrolling', // CSS class for styling
            rows: [
                // Rows within the form
                {
                    responsive: 'a5', // Responsive design identifier
                    type: 'wide', // Type of the element
                    cols: [left], // Include the left section
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screen size
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the export dropdown for small screens
                $$('pagerA').define('group', 1); // Define pager group for small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screen size
                $$('button-search').hide(); // Hide the search button
            }
            $.fn.scrollBottom = function () {
                // Add scrollBottom function to jQuery
                return $$(document).height() - this.scrollTop() - this.height(); // Calculate scroll bottom position
            };
        });
    }
}

// FILE DOCUMENTED
